export default __webpack_public_path__ + "static/media/t_1.4841af34.jpg";